import * as commonEnums from '../../enums';
const { PermissionLevel } = commonEnums;

export const isResourceViewOnly = (
  resources: CMxAPI.Resource[],
  resourceName: string
) => {
  return (
    resources.find(resources => resources.resourceName === resourceName)
      ?.permissionLevel === PermissionLevel.READ_ONLY
  );
};

export const isResourceFullAccess = (
  resources: CMxAPI.Resource[],
  resourceName: string
) => {
  return (
    resources.find(resources => resources.resourceName === resourceName)
      ?.permissionLevel === PermissionLevel.FULL_ACCESS
  );
};
